export class AccountDisplayNameFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "contains",
            "baseName": "contains",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "notContains",
            "baseName": "notContains",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AccountDisplayNameFilters.attributeTypeMap;
    }
    constructor() {
    }
}
